import React, { useMemo } from 'react';
import MenuBook from '@mui/icons-material/MenuBook';
import TipsAndUpdatesOutlined from '@mui/icons-material/TipsAndUpdatesOutlined';
import Download from '@mui/icons-material/Download';
import PieChartIcon from '@mui/icons-material/PieChart';
import Home from '@mui/icons-material/Home';
import AutoStories from '@mui/icons-material/AutoStories';
import { useTranslation } from 'react-i18next';
import UniversalSidebar, { SidebarSection, SidebarItem } from './UniversalSidebar';

interface PublicSidebarProps {
  mobileOpen: boolean;
  onDrawerToggle: () => void;
}

const PublicSidebar: React.FC<PublicSidebarProps> = ({ mobileOpen, onDrawerToggle }) => {
  const { t } = useTranslation('navigation');

  const menuItems = useMemo((): SidebarItem[] => [
    { id: 'home', text: t('menu.home'), icon: <Home />, path: '/' },
    { id: 'wiki', text: t('menu.wiki'), icon: <MenuBook />, path: '/wiki' },
    { id: 'guide', text: t('footer.guide'), icon: <TipsAndUpdatesOutlined />, path: '/guide' },
    { id: 'posts', text: t('footer.posts'), icon: <AutoStories />, path: '/posts' },
    { id: 'download', text: t('footer.download'), icon: <Download />, path: '/downloads' },
    { id: 'race-balance', text: t('footer.raceBalance'), icon: <PieChartIcon />, path: '/race-balance' },
  ], [t]);

  const sections = useMemo((): SidebarSection[] => [
    {
      id: 'menu-section',
      withMenuSection: true,
      items: menuItems,
    },
  ], [menuItems]);

  return (
    <UniversalSidebar
      sections={sections}
      mobileOpen={mobileOpen}
      onDrawerToggle={onDrawerToggle}
      mobileOnly
    />
  );
};

export default PublicSidebar;
